<script setup lang="ts">
import { useStore } from 'vuex';
import { computed } from 'vue';


const store = useStore()
const selectedProject = computed(() => store.getters['ai/selectedProject']);
const processedFiles = computed(() => selectedProject.value.processedFiles);


</script>

<template>
    <aside class="processed-files-displayer relative">
        <div class="processed-files-displayer-header">
            <h2>Projede Yer Alan Dosyalar</h2>
        </div>
        <ul class="processed-files-displayer-content">
            <li v-for="file in processedFiles" :key="file.id">
                    {{ file.name }}
            </li>
        </ul>

    </aside>
</template>

<style scoped>


.processed-files-displayer-header {
    font-size: 1.6rem;
    font-weight: 700;
    margin-bottom: 2.4rem;
    color: black;
}

ul.processed-files-displayer-content {
    list-style: disc;
    list-style-position: inside;
    overflow-y: auto;
    padding: 0;
    margin: 0;
}

.processed-files-displayer-content li {
    font-size: 1.4rem;
    color: black;
    margin-bottom: 1.6rem;
}



</style>